<script setup lang="ts">
import { computed } from 'vue'
import type { InputGroupButtonProps } from '.'
import { Button } from '@ds/primitives/button'

const props = withDefaults(defineProps<InputGroupButtonProps>(), {
  size: 'md',
  variant: 'ghost',
})

const buttonSize = computed(() => {
  switch (props.size) {
    case 'lg':
      return 'icon'
    default:
      return 'icon-sm'
  }
})
</script>

<template>
  <Button
    :variant="props.variant"
    :size="buttonSize"
    :class="props.class"
  >
    <slot />
  </Button>
</template>
